export default "__VITE_ASSET__PhblMGH8__"